import { getPortalDemographics } from 'demographics-client';
import Raven from 'raven-js';
export const fetchCompanyDetails = () => {
  return getPortalDemographics().catch(error => {
    Raven.captureException(error, {
      fingerprint: ['Failed to fetch company details']
    });
    throw error;
  });
};